module.exports = "/images/shield-checkmark-blue.svg?dbfdab5016c80ed761324fc976ec1888";